var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-card',{staticClass:"cardInfo"},[_c('profile-info'),_c('profile-follow'),(_vm.ownProfile)?_c('profile-edit'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }